import React from 'react';
import Tour from '../../../../../models/Tour';
import TourListItemSimple from '../../TourListItemSimple';
import TourItemDescription from '../../common/TourItemDescription';

interface TourThreeListItemProps {
    tour: Tour;
    showDetails?: boolean;
}

const TourThreeListItem: React.FC<TourThreeListItemProps> = ({ tour, showDetails = false }) => {
    return (
        <TourListItemSimple tour={tour} showDetails={showDetails}>
            <TourItemDescription tour={tour} />
        </TourListItemSimple>
    )
}

export default TourThreeListItem;